import { IHotelOfferTariffs, IHotelOfferTariff } from '../types';

const hotelOffersTariffsStore: IHotelOfferTariffs = {
    tariffs: [],
};

export default {
    namespaced: true,
    state: hotelOffersTariffsStore,
    mutations: {
        tariffsChanged(state: IHotelOfferTariffs, value: IHotelOfferTariff[]): void {
            state.tariffs = value;
        },
    },
};